import * as THREE from 'three'
import Experience from "../Experience"
import { gsap } from 'gsap/gsap-core'
import CustomEase from 'gsap/CustomEase'
gsap.registerPlugin(CustomEase)

const particlesFragmentShader = `
uniform vec3 uColorB;
    void main()
    {

    
        gl_FragColor =  vec4(uColorB, 1.0);
        #include <tonemapping_fragment>
        #include <colorspace_fragment>
}`

const particlesVertexShader =  `
uniform vec2 uResolution;
uniform float uProgress;

uniform vec3 uColorB;

attribute vec3 aPositionTarget;
attribute float aSize;

void main()
{


    vec3 mixedPosition = mix(position, aPositionTarget, uProgress);
    

    // Final position
    vec4 modelPosition = modelMatrix * vec4(mixedPosition, 1.0);
    vec4 viewPosition = viewMatrix * modelPosition;
    vec4 projectedPosition = projectionMatrix * viewPosition;
    gl_Position = projectedPosition;

   
    gl_PointSize = 0.002 * uResolution.y;
    

}`



export default class EarthSphere {
    constructor() {

        this.experience = new Experience()
        this.scene = this.experience.scene
        this.sizes = this.experience.sizes
        this.debug = this.experience.debug
        this.time = this.experience.time

        this.intManager = this.experience.interactionManager

        this.worker = new Worker('./assets/vendor/imageWorker.js');
        this.workerFlat = new Worker('./assets/vendor/imageWorker_flat.js');

        this.customEase =  CustomEase.create("custom", "M0,0 C0.29,0 0.294,0.056 0.346,0.179 0.499,0.544 0.231,0.512 0.365,0.821 0.504,1.144 0.704,1 1,1 ");


        this.particles= {}
        this.particles.positions = []
        this.particles.maxCount = 0;
        this.particles.index = 0;

        this.timeDuration = 6;

        this.particles.colorA = '#006385'
        this.particles.colorB = '#1C4A7E'





        // Material
        this.particles.material = new THREE.ShaderMaterial({

            vertexShader: particlesVertexShader,
            fragmentShader: particlesFragmentShader,
            uniforms:
            {
                uResolution: new THREE.Uniform(new THREE.Vector2(this.sizes.width * this.sizes.pixelRatio, this.sizes.height * this.sizes.pixelRatio)),
                uProgress: new THREE.Uniform(1.0),
                uColorB : new THREE.Uniform(new THREE.Color(this.particles.colorB)),
                uColorProgress : new THREE.Uniform(0.0),
                uTime: new THREE.Uniform(0.0)
            },
        })



        this.group = new THREE.Group()
        this.meshes = []

        const verticesCount = 1000 * 3
        const positions = new Float32Array(verticesCount * 3)

        for (let i = 0; i < verticesCount * 3; i++) {
            
            if(i % 3 === 0){
                // positions[i] = (Math.random() - 0.5)
                positions[i] = 0
            } else if( i % 3 === 1) {
                // positions[i] = (Math.random() - 0.5) * 200
                // positions[i] = Math.random() * 200 + 50
                // positions[i] = Math.random() * 200 + 50
                positions[i] = 0
            } else {
                positions[i] = Math.random() * 1000 * -1
            }
        }
        const geometry = new THREE.BufferGeometry()
        geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3))
        
        const material = new THREE.MeshBasicMaterial({color:'white'})
        const mesh = new THREE.Mesh(geometry, material)

        this.meshes.push(mesh)



        if (this.debug.active) {
            this.debugFolder = this.debug.ui.addFolder('Earth Particle Color')
            this.debugFolder.addColor(this.particles, 'colorB').onChange(() => {
                this.particles.material.uniforms.uColorB.value = new THREE.Color(this.particles.colorB)
            })
        }








        this.setMap()

        this.toLoad = 2;
        this.load = 0

        this.setSphere()

    }


    setMap() {

        // console.log(this)

        const image = new Image();
        image.onload = () => {
            image.needsUpdate = true;
            const imageCanvas = document.createElement('canvas');
            imageCanvas.width = image.width;
            imageCanvas.height = image.height;
            const context = imageCanvas.getContext('2d');
            context.drawImage(image, 0, 0);
            const imageData = context.getImageData(0, 0, imageCanvas.width, imageCanvas.height);


            this.workerFlat.postMessage({ imageData: imageData.data });
            this.workerFlat.onmessage = (e) => {
                const { dotCount } = e.data;
                createInstanceDots(dotCount);

                        // Send image data to the Web Worker
                    this.worker.postMessage({ imageData: imageData.data });

                    // Receive processed data from the Web Worker
                    this.worker.onmessage = (e) => {
                        const { dotCount } = e.data;
                        createInstanceDots(dotCount);
                    };

            }



           



        };

        image.src = './assets/img/exportimg/world.jpg';



        const createInstanceDots = (count) => {

            // this.particles.positions.push(count)



            const particlesGeometry = new THREE.BufferGeometry();
            const positions = new Float32Array(count.length);
            const colors = new Float32Array(count.length);
    
    
    
            for (let i = 0; i < count.length; i++) {
                positions[i] = count[i];
                        colors[i] = 0.2;
            }
    
            particlesGeometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));
            particlesGeometry.setAttribute('color', new THREE.BufferAttribute(colors, 3));
    
            const particlesMaterial = new THREE.MeshBasicMaterial({
                color: 0x235D9E,
                vertexColors: true,
                blending: THREE.AdditiveBlending,
                depthTest: false
            });
            particlesMaterial.size = 0.2;
            particlesMaterial.sizeAttenuation = true;
    
            const particles = new THREE.Mesh(particlesGeometry, particlesMaterial);
            this.group.add(particles);
            // this.group.visible = false;

            this.meshes.push(particles);

            this.load++

            if(this.toLoad === this.load){
                this.setParticles()
            }

        }
    }
    setParticles() {



        this.scatteredMesh()



        const positions = this.meshes.map(child => child.geometry.attributes.position)

        for(const position of positions){
            
            if(position.count > this.particles.maxCount){
                this.particles.maxCount = position.count
            }
        }

     

        
        for(const position of positions){
            const originalArray = position.array

            const newArray = new Float32Array(this.particles.maxCount * 3)



            for(let i=0; i<this.particles.maxCount; i++){
                const i3 = i * 3;

                if(i3 < originalArray.length){
                    newArray[i3 + 0] = originalArray[i3 + 0]
                    newArray[i3 + 1] = originalArray[i3 + 1]
                    newArray[i3 + 2] = originalArray[i3 + 2]
                }
                else {
                    const randomIndex = Math.floor(position.count * Math.random()) * 3
                    newArray[i3 + 0] = originalArray[randomIndex + 0]
                    newArray[i3 + 1] = originalArray[randomIndex + 1]
                    // newArray[i3 + 2] = 0
                    newArray[i3 + 2] = originalArray[randomIndex + 2]

                    // newArray[i3 + 0] = 0
                    // newArray[i3 + 1] = 0
                    // newArray[i3 + 2] = 0
                }


            }


            this.particles.positions.push(new THREE.Float32BufferAttribute( newArray, 3))


        }   

        const sizesArray = new Float32Array(this.particles.maxCount)

        for(let i =0; i< this.particles.maxCount; i++){
            // sizesArray[i] = Math.random() + 0.2
            sizesArray[i] = Math.random()
            // sizesArray[i] = 0.7

        }


        

        // // Geometry
        this.particles.geometry = new THREE.BufferGeometry()
        this.particles.geometry.setAttribute('position', this.particles.positions[0])
        this.particles.geometry.setAttribute('aPositionTarget', this.particles.positions[0])
        this.particles.geometry.setAttribute('aSize', new THREE.BufferAttribute(sizesArray, 1))






        


        // // Points
        this.particles.points = new THREE.Points(this.particles.geometry, this.particles.material)
        // this.particles.points.frustumCulled = false;

        this.scene.add(this.particles.points)
        


        


        this.particles.morph = index => {
            this.particles.geometry.attributes.position = this.particles.positions[this.particles.index]
            this.particles.geometry.attributes.aPositionTarget = this.particles.positions[index]

            gsap.fromTo(this.particles.material.uniforms.uProgress, {value:0}, {value:1, duration:() => this.timeDuration, ease:'power4'})
            this.particles.index = index

        }

        this.particles.morph0 = () => {this.particles.morph(0)}
        this.particles.morph1 = () => {this.particles.morph(1)}
        this.particles.morph2 = () => {this.particles.morph(2)}
        this.particles.morph3 = () => {this.particles.morph(3)}

        setTimeout(() => {
            this.particles.morph1()

        }, 1000);

        
    }

    scatteredMesh(){
        const verticesCount = 4000 * 3
        const positions = new Float32Array(verticesCount * 3)

        for (let i = 0; i < verticesCount * 3; i++) {
            
            // if(i % 3 === 0){
                positions[i] = (Math.random() - 0.5) * 60
                // positions[i] = 0
            // } else if( i % 3 === 1) {
                // positions[i] = (Math.random() - 0.5) * 100
            // } else {
                // positions[i] = (Math.random() - 0.5) * 100            }
        }
        const geometry = new THREE.BufferGeometry()
        geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3))
        
        const material = new THREE.MeshBasicMaterial({color:'white'})
        const mesh = new THREE.Mesh(geometry, material)

        this.meshes.push(mesh)
    }


    setSphere(){

        const colors = {
            base: '#0f2433', 
            edge: '#0f1e29'
        }

        const geometry = new THREE.SphereGeometry(6.7, 32, 32)
       // Shader Material
const material = new THREE.ShaderMaterial({
    uniforms:{
        base : new THREE.Uniform(new THREE.Color(colors.base)),
        edge : new THREE.Uniform(new THREE.Color(colors.edge)),
        uAlpha: new THREE.Uniform(0.0)
    },
    transparent: true,

    vertexShader: `
        varying vec3 vNormal;
        varying vec3 vViewDir;

        void main() {
            vNormal = normalize(normalMatrix * normal); // Transform normal to view space
            vec4 viewPos = modelViewMatrix * vec4(position, 1.0);
            vViewDir = normalize(-viewPos.xyz); // Calculate view direction
            gl_Position = projectionMatrix * viewPos; // Standard position transformation
        }
    `,
    fragmentShader: `
        varying vec3 vNormal;
        varying vec3 vViewDir;
        uniform vec3 base;
        uniform vec3 edge;
        uniform float uAlpha;

        void main() {
            // Calculate the Fresnel term
            float fresnel = abs(dot(vNormal, vViewDir));
            fresnel = 1.0 - fresnel; // Invert to highlight edges
            fresnel = pow(fresnel, 2.0); // Control sharpness of the effect

            // Set color with Fresnel intensity
            vec3 finalColor = mix(base, edge, fresnel);

            gl_FragColor = vec4(finalColor, uAlpha); // Output color
              #include <tonemapping_fragment>
            #include <colorspace_fragment>
        }
    `,
});

        this.sphere = new THREE.Mesh(geometry, material)
        this.scene.add(this.sphere)

        // this.sphere.scale.set(0,0,0)
        this.sphere.scale.set(1.014,1.014,1.014)



        if (this.debug.active) {
            this.debugFolder = this.debug.ui.addFolder('sphere  Color')
            this.debugFolder.addColor(colors, 'base').onChange(() => {
                material.uniforms.base.value = new THREE.Color(colors.base)
            })
            this.debugFolder.addColor(colors, 'edge').onChange(() => {
                material.uniforms.edge.value = new THREE.Color(colors.edge)
            })
        }

    }




    
}